class AdminRequest{

  constractor(){

    this.user_Name=null;
     this.password=null;
     this.role=null;
    
  }}
  export default AdminRequest;